<script>
  import {Bar, mixins} from 'vue-chartjs'

  export default {
    extends: Bar,
    mixins: [mixins.reactiveProp],
    props: ['chartData'],
    data () {
      let that = this

      return {
        options: {
          scales: {
            xAxes: [{
              display: false,
              barPercentage: 0.7
            }],
            yAxes: [{
              display: false,
              ticks: {
                beginAtZero: true,
                suggestedMax: 10
              }
            }]
          },
          legend: {
            display: false
          },
          tooltips: {
            backgroundColor: 'rgba(220, 220, 220, 0.8)',
            bodyFontColor: '#2c2c2c',
            bodySpacing: 5,
            callbacks: {
              title: function (tooltipItem, data) {
                return null
              },
              label: function (tooltipItem, data) {
                let dataset = data.datasets[tooltipItem.datasetIndex]
                let index = tooltipItem.index
                let label = dataset.labels ? `${dataset.labels[index]}: ${that.$currency}` : ''
                return `${label}${tooltipItem.yLabel}`
              }
            },
            cornerRadius: 0,
            xPadding: 10,
            yPadding: 10
          }
        }
      }
    },
    mounted () {
      this.renderChart(this.chartData, this.options)
    }
  }
</script>


// WEBPACK FOOTER //
// src/js/components/charts/SimpleBarChart.vue